import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { PartnerService } from 'src/app/features/partner/partner.service';
import { PaperRecord } from '../../models/paper-records.model';
import { WsHelperService } from '@shared/services/ws-helper.service';
import {
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow
} from '@angular/material/table';
import { UpperCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-paper-records',
  templateUrl: './paper-records.component.html',
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    UpperCasePipe,
    TranslateModule
  ]
})
export class PaperRecordsComponent implements OnInit {
  private partnerService = inject(PartnerService);
  private cd = inject(ChangeDetectorRef);
  private readonly wsHelperService = inject(WsHelperService);

  paperRecordsData: PaperRecord[];
  paperRecordsTotal: number;
  readonly displayedColumns: string[] = ['partner', 'treatmentCenter', 'paperRecords'];

  ngOnInit() {
    this.getPaperRecords();
  }

  private getPaperRecords(): void {
    this.wsHelperService.callWithSpinner(this.partnerService.getPaperRecords()).subscribe(records => {
      this.paperRecordsData = records.data;
      this.paperRecordsTotal = records.total;
      this.cd.detectChanges();
    });
  }
}
